import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    LinearProgress,
    Link,
    Menu,
    MenuItem,
    Select,
    SelectChangeEvent,
    SelectProps,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { LoggedInUserInfo } from "../../components/Elements/loggedInUserInfo";
import { RightNav } from "../../components/Nav/RightNav";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import BasicTabs, { FMTabs } from "../Tabs";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/EditOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import {
    DataGrid,
    getGridStringOperators,
    GridColDef,
    GridColumnMenuContainer,
    GridColumnMenuProps,
    GridColumnsMenuItem,
    GridFilterMenuItem,
    GridFilterModel,
    GridFilterOperator,
    GridRowId,
    GridSelectionModel,
    GridSortModel,
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton,
    HideGridColMenuItem,
    SortGridMenuItems,
} from "@mui/x-data-grid";
import moment from "moment";
import { useParams } from "react-router-dom";
import { PolicyDocumentsPopup } from "./PolicyDocumentsPopup";
import { PolicyErrorPopup } from "./PolicyErrorsPopup";
import { AddDocument } from "../../CustomerPanel/AddDocuments";
import { RiExpandUpDownLine } from "react-icons/ri";
import { ArrowForward, ArrowRight, ArrowRightAlt, KeyboardArrowDown, KeyboardArrowUp, FileDownload, Email } from "@mui/icons-material";
import { FaRegEdit } from "react-icons/fa";
import { size } from "lodash";
import { margin, Stack } from "@mui/system";
import React from "react";
import { FMFilters, NewCompletedFilingsModel, getCompletedFilings__Resp, getPolicyFilingAndReport } from "../../models/NewCompletedFilingsModel";
import { MenuDropdown } from "../../components/Elements/MenuDropdown";
import Swal from "sweetalert2";
import { DataGridPro, DataGridProProps, useGridApiRef } from "@mui/x-data-grid-pro";
import FilerNotes from "../../components/Elements/filerNotes";
import formatPrice from "../../helper/currencyFormatter";
import { formatUtcToLocal, mstDateStringToUtcIsoString } from "../../helper/utils";
import { boolean } from "yup";
import { getRowsPerPageOptions } from "../../components/AddEdit/CustomFunctions";
import { apiClient } from "../../helper/api";
import useAppDialog from "../../hooks/useAppDialog";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { DialogResponse, DialogResult } from "../../components/Dialog/dialogTypes";
import { AppFlags } from "../../helper/config";

interface Iprops {
    NewCompletedFilingsCL: getCompletedFilings__Resp;
    fetchFilingQueueData: (
        pageNumber: number,
        pageSize: number
    ) => void;
    closePolicy: (
        custPolicyId: number,
        action: string,
        value: number,
        message: string,
        isClosed: boolean
    ) => void;
    getCustomerPolicyListbyTaxType: (
        action: string,
        customerPolicyIds: number[],
        option: string
    ) => void;
    getCustomerPolicyDetails: (customerPolicyIds: number) => Promise<string>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
    currentPage: number
    setPageSize: React.Dispatch<React.SetStateAction<number>>
    pageSize: number
    sortModel: any;
    filterModel: any;
    setFilterModel: React.Dispatch<React.SetStateAction<any>>;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
    setSelectedRows: React.Dispatch<React.SetStateAction<NewCompletedFilingsModel[] | null>>;
    selectedRows: NewCompletedFilingsModel[] | null;
}

export const ReadyToFilings: React.FC<Iprops> = ({
    NewCompletedFilingsCL,
    fetchFilingQueueData,
    closePolicy,
    getCustomerPolicyListbyTaxType,
    getCustomerPolicyDetails,
    setCurrentPage,
    currentPage,
    setPageSize,
    pageSize,
    sortModel,
    filterModel,
    setFilterModel,
    setSortModel,
    setSelectedRows,
    selectedRows,
}) => {
    const { user } = useAuth();
    const token = user?.token;
    const theme = useTheme();
    const isTabletOrDown = useMediaQuery(theme.breakpoints.down('md'));
    const [loading, setloading] = useState(false);
    const [Formdata, setFormData] = useState([]);
    const [Open, setOpen] = useState(false);
    const params = useParams();
    const [OpenError, setOpenError] = useState(false);
    const [ErrorFormdata, setErrorFormData] = useState([]);
    const [custPolId, setcustPolId] = React.useState("0");
    const [OpenDocResubmission, setDocResubmission] = React.useState(false);
    const [selectedStatus, setselectedStatus] = useState("");
    const [openNotesDialog, setOpenNotesDialog] = useState(false);
    const [CurrentStatus, setCurrentStatus] = useState('');
    const [currentPolicySubStatus, setCurrentPolicySubStatus] = useState<string>('');

    const readyToFileGridApiRef = useGridApiRef();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleClickOpenActionOptions = (customerPolicyId: number) => {
        const buttonEl = document.getElementById(`action-options-button-${customerPolicyId}`) as HTMLElement | null;
        setAnchorEl((prev) => (prev?.id === `action-options-button-${customerPolicyId}` ? null : buttonEl));
    };
    const handleCloseActionOptions = () => {
        setAnchorEl(null);
    };

    const handleDocumentReubmission = (custPolId: number) => {
        setcustPolId(String(custPolId));

        setDocResubmission(true);
    };

    const handleOpenNotesDialog = (status: string) => {
        setCurrentStatus(status)
        setOpenNotesDialog(true);
    };
    const handleSubmitNotes = (data: any) => {
        const { noteDetail } = data;
        console.log("Notes submitted: ", noteDetail); // Debugging log
        setOpenNotesDialog(false);
        setCurrentStatus('');

        updateStatus(data.status, selectedRows, noteDetail, data.policySubStatus, data.dateDeclarationFiled);
    };

    const handleCloseNotesDialog = () => {
        setCurrentStatus('')
        setOpenNotesDialog(false);
    };

    const onRowsSelectionHandler = (ids: GridSelectionModel) => {
        const selectedIDs = new Set(ids);
        const uniqueRowsIds = new Set();
        const selectedRowData = NewCompletedFilingsCL.getCompletedFilings_Respdata.filter((row) => {
            if (selectedIDs.has(row?.customerPolicyId ?? "") && !uniqueRowsIds.has(row?.customerPolicyId ?? "")) {
                uniqueRowsIds.add(row?.customerPolicyId ?? "");
                return true;
            }
            return false;
        });

        if (ids[0] != null || undefined) {
            setselectedStatus(
                NewCompletedFilingsCL.getCompletedFilings_Respdata.find((x) => x?.customerPolicyId === Number(ids[0]))?.status ?? ""
            );
        } else {
            setselectedStatus("");
        }
        if (ids[0] != null || undefined) {
            setselectedState(
                NewCompletedFilingsCL.getCompletedFilings_Respdata.find((x) => x?.customerPolicyId === Number(ids[0]))?.homeState ?? ""
            );
        } else {
            setselectedState("");
        }

        setSelectedRows(selectedRowData);
    };

    const handleExport = (option: string) => {

        var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];

        getCustomerPolicyListbyTaxType("getCustomerPolicyListbyTaxType", customerPolicyIds, option);
    };
    const exportOptions = [
        'Short', 'Detailed'
    ]
    const exportOptionsAdmin = [
        'Short', 'Detailed', 'All'
    ]
    const SumitToSLA = () => {

        const MultiplePolicyIds: string =
            selectedRows?.map((x) => x.customerPolicyId).join(",") ?? "";

        if (MultiplePolicyIds === "") {
            alert("Please Select at least one Filing");
            return;
        }

        apiClient(`/SLIPSubmission/SubmitPolicyToState?custPolicyIdList=${MultiplePolicyIds}`,
            {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
            }
        )
            .then((responseJson) => {
                if (!responseJson) return

                alert(responseJson.data);
                if (MultiplePolicyIds === "") {
                    alert("Please Select at least one Filing");
                    return;
                }
            })
    };

    const handleSendEmail = () => {
        if (!selectedRows || selectedRows.length === 0) {
            // If no rows are selected, show a message to the user
            alert("Please select row before sending an email");
            return;
        }

        const MultiplePolicyIds: string = selectedRows?.map(x => x.customerPolicyId).join(",") ?? ""
        apiClient(`/ProcessPolicyChecks/SendChecksEmailMultiple?customerPolicyIdList=${MultiplePolicyIds}`,
            {
                method: "POST",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response
                alert("Email sent");
            })

    };

    const handleMultipleDownload = () => {
        var MultiplePolicyIds: string =
            selectedRows?.map((x) => x.policyId).join(",") ?? "";

        const PendingstateRows = selectedRows?.filter(row => row.status === "Pending state review" || row.status === "Ready to File");
        MultiplePolicyIds = PendingstateRows?.map(x => x.policyId).join(",") ?? "";

        // if (hasNonPendingStateReview) {
        Swal.fire({
            title: 'Confirmation!',
            text: 'You can download document only for "Pending state review" or "Ready to File" Filings. Proceed anyway?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (MultiplePolicyIds === "") {
                    alert("Please Select at least one Filing or policyid does not exist.");
                    return;
                }
                setloading(true);
                //call api to save data
                apiClient(`/PolicyFilings/getMultiplePolicyBatchSubmissionData?MultiplePolicyIds=${MultiplePolicyIds}`,
                    {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        }),

                    }
                )
                    .then((res) => {
                        if (!res) return
                        if (res.resp === 1) {
                            alert(res.message);
                            setloading(false);
                            return;
                        }
                        console.log(res.data, "readyTofiledata");
                        if (res.data != "") {
                            window.open(res.data, "_blank");
                            fetchFilingQueueData(currentPage, pageSize);

                        } else {
                            alert("Something went wrong");
                        }

                    })
                    .finally(() => {
                        setloading(false);
                    });
            }
            else {
                setloading(false);
                return;
            }
        });


    };
    const handleEdit = (custPolId: number) => {
        apiClient(`/PolicyDashBoard/getCustomerPolicyDocuments?CustPolicyId=${custPolId}`,
            {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
            }
        )
            .then((responseJson) => {
                // Do something with the response
                console.log(responseJson);
                setFormData(responseJson.data);
            })

        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setOpenError(false);
        setDocResubmission(false);
    };

    const handleCloseDocumentUpload = () => {
        setDocResubmission(false);
        void fetchFilingQueueData(currentPage, pageSize);
    };

    const [selectedState, setselectedState] = useState("");

    const [selectedSLIPPartnerId, setSelectedSLIPPartnerId] = useState(0);
    const initialPartnerData = { partnersId: 0, customerName: "" };
    const [SLIPCustomer, setSLIPCustomer] = useState([initialPartnerData]);
    const fetchSLIPCustomer = () => {
        apiClient("/Partners/getCASLAPartners", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response

                setSLIPCustomer(responseJson.data);
            })
    };

    const handlehandleApprove = (custPolId: number) => {
        setloading(true);
        apiClient(`/PolicyDashBoard/Approve?custPolId=${custPolId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response
                setloading(false);
                //fetch data
                fetchFilingQueueData(currentPage, pageSize);
                setloading(false);

            })
            .finally(() => {
                setloading(false);
            });
    };

    useEffect(() => {
        fetchSLIPCustomer();
    }, []);

    const initialdata: NewCompletedFilingsModel = {
        customerPolicyId: 0,
        homeState: "",
        policyId: 0,
        dueDate: ""
    }
    const { openDialog_Message } = useAppDialog()
    const handleSendMessage = async (custPolId: number, status: string) => {
        try {
            setloading(true);

            openDialog_Message({
                custPolId: String(custPolId)
            }).then((res: DialogResponse) => {
                if (res.dialogResult === DialogResult.OK) {
                    // Do something with the message

                }
                return res
            })
            setloading(false);

        } catch (error) {
            setloading(false);
            console.log(error);
        }
    };
    const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = React.useState<GridRowId[]>([]);
    const handleDetailPanelExpandedRowIdsChange = React.useCallback((newIds: GridRowId[]) => {
        setDetailPanelExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds,);
    },
        [],
    );
    const filterOperators = getGridStringOperators().filter(({ value }) => ['contains'].includes(value));
    const equalOperators: GridFilterOperator<any, string | number | null, any>[] = getGridStringOperators().filter(({ value }) => ['equals'].includes(value));

    const getDetailPanelContent = React.useCallback<NonNullable<DataGridProProps['getDetailPanelContent']>>(({ row }) => <DetailPanelContent row={row} />, []);
    const getDetailPanelHeight = React.useCallback(() => 200, []);
    function DetailPanelContent({ row }: { row: NewCompletedFilingsModel }) {
        const [TaxNamAndData, setTaxNamAndData] = useState<NewCompletedFilingsModel[]>([initialdata]);
        const [isLoadingChild, setIsLoadingChild] = useState(true);
        const TaxNameAndDate = () => {

            setTaxNamAndData([])
            setIsLoadingChild(true);
            apiClient(`/PolicyDashBoard/getaxTypeandDateByCustpolicyid?customerPolicyId=${row.customerPolicyId}`,
                {
                    method: "GET",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    })
                })
                .then((responseJson) => {
                    if (!responseJson) return
                    // Do something with the response
                    if (responseJson.data != null) {

                        setTaxNamAndData(responseJson.data)
                        setIsLoadingChild(false);
                        console.log("taxData", responseJson)

                    }

                })
        }
        useEffect(() => {
            TaxNameAndDate();
        }, [row])

        const rows = [
            {
                TaxNamAndData
            }
        ];
        return (

            <Stack direction="column" spacing={1} sx={{ height: 1 }} style={{ paddingLeft: isTabletOrDown ? '50px' : '170px'}} className="hide-border-12" >

                <DataGridPro
                    loading={isLoadingChild}
                    columns={[
                        {
                            field: 'taxType',
                            type: 'string',
                            headerName: 'Tax Type',
                            flex: 1,
                            headerAlign: "left",
                            hideSortIcons: true,
                            maxWidth: 200,
                            renderHeader: (params) => (
                                <div>
                                    <span className="table-card-title" >{params.colDef.headerName}</span>
                                    <RiExpandUpDownLine />
                                </div>
                            ),
                            align: "left",
                        },

                        {
                            field: 'taxAmt', hideSortIcons: true,
                            renderHeader: (params) => (
                                <div>
                                    <span className="table-card-title" >{params.colDef.headerName}</span>
                                    <RiExpandUpDownLine />
                                </div>
                            ), type: 'string', headerName: 'Tax Amount', flex: 0.5, align: 'right', headerAlign: 'right', maxWidth: 150, renderCell: (params) => {
                                const value = params.value || '0'; // Default to '0' if value is null or undefined
                                return (
                                    <Box display="flex" alignItems="left" justifyContent="left">

                                        {formatPrice(value)}

                                    </Box>
                                )
                            }


                        },


                    ]}
                    rows={TaxNamAndData}
                    getRowId={(r) => r?.rowNum ?? 0}
                    sx={{
                        flex: 1,
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc !important',
                            borderBottom: '2px solid #e2e8f0 !important',
                        },
                    }}
                    hideFooter
                />
            </Stack>
        );
    }

    const columns: GridColDef[] = [
        {
            field: 'dueDate', hideSortIcons: true,
            valueGetter: (params) =>
            (
                new Date(params.row.dueDate)
            ),
            renderCell: (params) =>
            (
                <div>
                    {(params.row.dueDate != null && params.row.dueDate != '') ? formatUtcToLocal(params.row.dueDate, "MM/DD/YYYY") : ""}
                </div>
            ),
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dueDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            type: 'string', headerName: 'Filing Due Date', minWidth: 170, flex: 0.5, align: 'left', headerAlign: 'left',
        },
        {
            field: 'Action', flex: 0.8, minWidth: 90, filterable: false, hideSortIcons: true,
            sortable: false,
            disableColumnMenu: true,
            headerName: "Action", headerAlign: 'center', align: 'center', disableExport: true,
            renderCell: (params) =>
            (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <Button
                            size="small"
                            style={{ minWidth: '0px' }}
                            id={`action-options-button-${params.row.customerPolicyId}`}
                            aria-controls={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? `action-options-menu-${params.row.customerPolicyId}` : undefined}
                            aria-haspopup="true"
                            aria-expanded={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? 'true' : undefined}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleClickOpenActionOptions(params.row.customerPolicyId);
                            }}
                        >
                            <MoreVertOutlinedIcon fontSize="small" />
                        </Button>
                        <Menu
                            id={`action-options-menu-${params.row.customerPolicyId}`}
                            aria-labelledby={`action-options-button-${params.row.customerPolicyId}`}
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl && anchorEl.id === `action-options-button-${params.row.customerPolicyId}`)}
                            onClose={handleCloseActionOptions}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            MenuListProps={{
                                'aria-labelledby': `action-options-button-${params.row.customerPolicyId}`,
                            }}
                            sx={{
                                '& .MuiMenuItem-root': {
                                    fontSize: '14px',
                                    padding: '8px 16px',
                                },
                            }}
                        >
                            {params.row?.policyId === null ? (
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                                    <Link href={'/Admin/AddEditCustomerPolicyDetails/' + params.row.customerPolicyId} color="inherit" sx={{ textDecoration: 'none' }} target="">
                                        <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Update Policy
                                    </Link>
                                </MenuItem>
                            ) : (
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                                    <Link href={'/Transaction/' + params.row?.policyId + '/' + params.row?.customerPolicyId} color="inherit" sx={{ textDecoration: 'none' }} target="">
                                        <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Check Policy
                                    </Link>
                                </MenuItem>
                            )}
                            {params.row?.status === "Pending state review" ? (
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); handlehandleApprove(params.row.customerPolicyId); }}>
                                    <VerifiedUserIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Approve
                                </MenuItem>
                            ) : null}
                            {/* <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); handleDocumentReubmission(params.row.customerPolicyId); }}>
                                <UploadFileIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Upload documents
                            </MenuItem> */}
                            {params.row.isClient === 1 ? (
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); handleSendMessage(params.row.customerPolicyId, params.row.status); }}>
                                    <MailOutlineIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Send Message
                                </MenuItem>
                            ) : null}
                        </Menu>
                    </Box>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px', width: '100%' }}>
                        {params.row.filerNotes && params.row.filerNotes.trim() !== "" ? (
                            <Tooltip
                                placement="top"
                                title={
                                    <div style={{
                                        maxWidth: "320px",
                                        fontSize: "16px",
                                        textAlign: "left",
                                        whiteSpace: "pre-line",
                                    }}>
                                        {params.row.filerNotes}
                                    </div>
                                }
                                arrow
                            >
                                <IconButton
                                    size="small"
                                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}>
                                    <InfoOutlinedIcon fontSize="small" color="primary" />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </div>
                </>
            )
        },
        {
            field: 'agency', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'agency'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Client', flex: 0.35, minWidth: 120, align: 'left', headerAlign: 'left', filterOperators
        },
        {
            field: 'invoiceNumber', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'invoiceNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Invoice Number', minWidth: 175, flex: 0.68, align: 'left', headerAlign: 'left', filterOperators
        },

        {
            field: 'insuredName',
            type: 'string',
            headerName: 'Insured Name',
            flex: .6,
            headerAlign: "left",
            hideSortIcons: true,
            minWidth: 165,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'insuredName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )
            },
            align: "left", filterOperators
        },
        {
            field: 'policyNumber',
            type: 'string',
            headerName: 'Policy Number',
            flex: 0.65,
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'policyNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )
            },
            headerAlign: "left",
            align: "left",
            minWidth: 170,
            filterOperators,
        },

        {
            field: "homeState",
            type: "string",
            headerName: "Home State",
            flex: 0.55,
            minWidth: 150,
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'homeState'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )
            },
            align: "center",
            headerAlign: "left",
            filterOperators,
        },

        {
            field: "transactionTypeName",
            type: "string",
            headerName: "Transaction Type",
            minWidth: 190,
            flex: 0.7, hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'transactionTypeName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}   
                </div>
            )
            },
            align: "left",
            headerAlign: "left",
            filterOperators,
        },
        // {
        //     field: 'invoiceDate', hideSortIcons: true,
        //     renderHeader: (params) => (
        //         <div>
        //             <span className="table-card-title " >{params.colDef.headerName}</span>
        //             <RiExpandUpDownLine />
        //         </div>
        //     ), type: 'date', headerName: 'Invoice Date', flex: 0.6, align: 'center', headerAlign: 'center',
        //     valueGetter: (params) =>
        //     (
        //         new Date(params.row.invoiceDate)
        //     ),
        //     renderCell: (params) =>
        //     (
        //         <div>
        //             {(params.row.invoiceDate != null && params.row.invoiceDate != '') ? formatUtcToLocal(params.row.invoiceDate, "MM/DD/YYYY") : ""}
        //         </div>
        //     )
        // },
        // {
        //     field: 'effectiveDate', hideSortIcons: true,
        //     renderHeader: (params) => (
        //         <div className="d-flex align-items-center" >
        //             <span className="table-card-title word-wrap-1 p-0 " >{params.colDef.headerName}</span>
        //             <RiExpandUpDownLine />
        //         </div>
        //     ), type: 'date', headerName: 'Policy Effective Date', flex: 0.6, align: 'center', headerAlign: 'center',
        //     valueGetter: (params) =>
        //     (
        //         new Date(params.row.effectiveDate)
        //     ),
        //     renderCell: (params) =>
        //     (
        //         <div>
        //             {(params.row.effectiveDate != null && params.row.effectiveDate != '') ? formatUtcToLocal(params.row.effectiveDate, "MM/DD/YYYY") : ""}
        //         </div>
        //     )
        // },
        // {
        //     field: 'policyExpDate', hideSortIcons: true,
        //     renderHeader: (params) => (
        //         <div className="d-flex align-items-center" >
        //             <span className="table-card-title word-wrap-1 p-0 " >{params.colDef.headerName}</span>
        //             <RiExpandUpDownLine />
        //         </div>
        //     ), type: 'date', headerName: 'Policy Expiration Date', flex: 0.7, align: 'center', headerAlign: 'center',
        //     valueGetter: (params) =>
        //     (
        //         new Date(params.row.policyExpDate)
        //     ),
        //     renderCell: (params) =>
        //     (
        //         <div>
        //             {(params.row.policyExpDate != null && params.row.policyExpDate != '') ? formatUtcToLocal(params.row.policyExpDate, "MM/DD/YYYY") : ""}
        //         </div>
        //     )
        // },

        {
            field: 'invoiceDate', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'invoiceDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title " >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Invoice Date', flex: 0.7, minWidth: 160, align: 'left', headerAlign: 'left', filterOperators: equalOperators,
            renderCell: (params) =>
            (
                <div>
                    {(params.row.invoiceDate != null && params.row.invoiceDate != '') ? formatUtcToLocal(params.row.invoiceDate, "MM/DD/YYYY") : ""}
                </div>
            )
        },
        {
            field: 'effectiveDate', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'effectiveDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title " >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Policy Effective Date', minWidth: 210, flex: 0.7, align: 'left', headerAlign: 'left', filterOperators: equalOperators,
            renderCell: (params) =>
            (
                <div>
                    {(params.row.effectiveDate != null && params.row.effectiveDate != '') ? formatUtcToLocal(params.row.effectiveDate, "MM/DD/YYYY") : ""}
                </div>
            )
        },

        {
            field: 'policyExpDate', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'policyExpDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title " >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Policy Expiration Date', minWidth: 220, flex: 0.7, align: 'left', headerAlign: 'left', filterOperators: equalOperators,
            renderCell: (params) =>
            (
                <div>
                    {(params.row.policyExpDate != null && params.row.policyExpDate != '') ? formatUtcToLocal(params.row.policyExpDate, "MM/DD/YYYY") : ""}
                </div>
            ),

        },

        {
            field: 'grossPremium',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'grossPremium'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )
            },
            type: 'string',
            headerName: 'Gross Premium',
            flex: 0.5,
            align: 'right',
            minWidth: 175,
            headerAlign: 'right',
            filterOperators,
            renderCell: (params) => {
                let grossPremium = params.value || '0'; // Default to '0' if value is null or undefined

                // Trim any spaces and remove the dollar sign and commas
                let cleanedValue = grossPremium.replace(/[,\$]/g, "").trim();

                // If the value is in parentheses, it's negative, so handle that
                if (cleanedValue.startsWith("(") && cleanedValue.endsWith(")")) {
                    cleanedValue = "-" + cleanedValue.slice(1, -1); // Remove parentheses and add a negative sign
                }

                // Convert to number
                const numericValue = parseFloat(cleanedValue);

                // If numericValue is a valid number, format it; otherwise, return the original string
                return (
                    <Box display="flex" alignItems="left" justifyContent="center">
                        {isNaN(numericValue) ? grossPremium : `${formatPrice(numericValue.toString())}`}
                    </Box>
                );
            }
        },

        {
            field: 'status', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'status'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Status', minWidth: 130, flex: 0.4, align: 'left', headerAlign: 'left', filterOperators,
        },   
    ];
    function CustomToolbar() {
        return (
            <GridToolbarContainer  >
                <GridToolbarFilterButton className="me-3 sky-blue" />
                <GridToolbarColumnsButton className="me-3 sky-blue" />
                <GridToolbarExport className="me-3 sky-blue" />
            </GridToolbarContainer>

        );
    }
    function EditToolbar() {
        const [toolbarMenuAnchor, setToolbarMenuAnchor] = useState<null | HTMLElement>(null);
        const openToolbarMenu = Boolean(toolbarMenuAnchor);

        const handleToolbarMenuClose = () => setToolbarMenuAnchor(null);
        const handleToolbarAction = (action: 'filter' | 'columns' | 'exportCsv' | 'exportPrint') => {
            handleToolbarMenuClose();
            const api = readyToFileGridApiRef.current;
            if (!api) return;
            if (action === 'filter') api.showFilterPanel();
            else if (action === 'columns') (api as any).showPreferences('columns');
            else if (action === 'exportCsv') api.exportDataAsCsv();
            else if (action === 'exportPrint') api.exportDataAsPrint();
        };

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, py: 1.5, px: 1 }}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#334155', mr: 'auto', pl: 1 }}>Ready to File</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {isTabletOrDown ? (
                        <>
                            <IconButton
                                aria-label="Table options"
                                aria-controls={openToolbarMenu ? 'table-options-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openToolbarMenu ? 'true' : undefined}
                                onClick={(e) => setToolbarMenuAnchor(e.currentTarget)}
                                sx={{ color: '#2099d2' }}
                            >
                                <MoreVertOutlinedIcon />
                            </IconButton>
                            <Menu
                                id="table-options-menu"
                                anchorEl={toolbarMenuAnchor}
                                open={openToolbarMenu}
                                onClose={handleToolbarMenuClose}
                                MenuListProps={{ 'aria-labelledby': 'table-options-button' }}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            >
                                <MenuItem onClick={() => handleToolbarAction('filter')}>Filter</MenuItem>
                                <MenuItem onClick={() => handleToolbarAction('columns')}>Columns</MenuItem>
                                <MenuItem onClick={() => handleToolbarAction('exportCsv')}>Download as CSV</MenuItem>
                                <MenuItem onClick={() => handleToolbarAction('exportPrint')}>Print</MenuItem>
                            </Menu>
                        </>
                    ) : (
                        <CustomToolbar />
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    {/* {(selectedStatus === "Pending state review" || selectedStatus === "Ready to File") && !user?.userRoles.split(",").includes("MISC State Reporter") && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleMultipleDownload}
                            startIcon={<FileDownload />}
                            sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#4f46e5' } }}
                        >
                            Download
                        </Button>
                    )} */}
                    {selectedStatus === "FileMule Flags" && !user?.userRoles.split(",").includes("MISC State Reporter") && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleSendEmail}
                            startIcon={<Email />}
                            sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#4f46e5' } }}
                        >
                            Send Email
                        </Button>
                    )}
                    {selectedRows?.length !== 0 && selectedRows?.length !== undefined && (
                        <Box sx={{ zIndex: 9 }}>
                            <MenuDropdown menuTitle="Status" items={status} onItemClick={handleStatus}
                            sx={{
                                fontWeight: 600,
                                backgroundColor: '#2099d2',
                                '&:hover': { backgroundColor: '#176990' },
                                px: 2,
                            }} />
                        </Box>
                    )}
                    <Box sx={{ zIndex: 9 }}>
                        <MenuDropdown
                            menuTitle="Export"
                            items={user?.userRoles.split(",").includes("Super Admin") ? exportOptionsAdmin : exportOptions}
                            onItemClick={handleExport}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#2099d2',
                                '&:hover': { backgroundColor: '#176990' },
                                px: 2,
                            }}
                            startIcon={<FileDownload />}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    function checkSelectedRowsForNY(): boolean {
        if (selectedRows?.find(x => x.homeState === 'NY')) {
            if (selectedRows.find(x => x.homeState !== 'NY')) {
                Swal.fire({
                    title: 'Warning!',
                    text: "Please select filings either specifically for New York or those that exclude New York, as there is a special rule for changing the status in New York.",
                    iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    // showCancelButton: true,
                    confirmButtonColor: '#02A4E3',
                    // cancelButtonColor: '#d33',
                    // confirmButtonText: 'Proceed',
                    customClass: {
                        confirmButton: 'btn-radius',
                        // cancelButton: 'btn-radius',
                        popup: 'card-radius'
                    }
                })
                    .then((result) => {

                    });
                return false;
            }


        }
        return true;
    }
    function handleStatus(status: string) {
        if (!checkSelectedRowsForNY()) {
            return;
        }

        setCurrentPolicySubStatus('');
        const isNewYorkFiling = selectedRows && selectedRows?.length === 1 && selectedRows[0].homeState === 'NY' && (selectedRows[0].transactionTypeName === 'New Business' || selectedRows[0].transactionTypeName === 'Renewal Business')


        // Show the 'Filer Notes' modal when status is 'Filed' for a single NY New/Renewal filing
        if (status === 'Filed' && isNewYorkFiling) {
            (async () => {
                try {
                    const response = await getCustomerPolicyDetails(selectedRows?.[0]?.customerPolicyId ?? 0);
                    setCurrentPolicySubStatus(response ?? '');
                } catch {
                    // If sub-status lookup fails (e.g., no CustomerPolicyData row yet),
                    // still open NY filing questions and continue the required workflow.
                    setCurrentPolicySubStatus('');
                }
                handleOpenNotesDialog(status);
            })();
            return;
        }

        // Show warning if NY state exists in the selected rows for a Filed action and more than one row is selected
        if (selectedRows?.find(m => m.homeState === "NY") && selectedRows.length !== 1 && status === "Filed") {
            Swal.fire({
                title: "",
                text: "Please select one filing for 'New York' state",
                icon: 'warning',
                confirmButtonText: "OK",
            });
            return;
        }

        // Otherwise, show a confirmation modal to update the status
        Swal.fire({
            title: 'Confirmation!',
            text: "Do you want to update customer policy's status as " + status + "?",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    setloading(true);
                    if (status !== undefined && status !== '' && status !== null) {
                        count = 0;
                        SetCustPolicyNullDueDateData(null);
                        updateStatus(status, selectedRows);
                    }
                }
            });

        setloading(false);
    }
    const parseDueDate = (dueDateStr: string): Date => {
        const currentDate = new Date();
        const [month, day] = dueDateStr.split('-').map(Number);
        const year = currentDate.getFullYear();
        return new Date(year, month - 1, day);
    };
    const isDueDateWithinRange = (dueDateStr: string): boolean => {
        const currentDate = new Date();
        const dueDate = parseDueDate(dueDateStr);
        const dateDifference = dueDate.getTime() - currentDate.getTime();
        const dayDifference = dateDifference / (1000 * 3600 * 24);
        return dayDifference >= 0 && dayDifference <= 9;
    };
    var count = 0;
    function updateStatus(status: string, selectedRow: any, notes: string = '', policySubStatus: string = '', dateDeclarationFiled: string = '') {
        const noteDate = formatUtcToLocal(new Date().toISOString(), "MM/DD/YYYY");
        if (status === "Filed") {
            var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
            if (count === 0) {
                (async () => {
                    try {
                        const response = await getTaxTypeData('getIsPolicyFilingAndReportByCustPolIds', customerPolicyIds);

                        if (response != null && response.length > 0) {
                            const dueDateNotValid: NewCompletedFilingsModel[] = []; // where due date is not prior - 10 days of due date
                            response.forEach((e: getPolicyFilingAndReport) => {
                                if (e.report == true) {
                                    var newData = selectedRows?.find(m => m.customerPolicyId == e.customerPolicyId);
                                    if (!isDueDateWithinRange(newData?.dueDate) && newData !== undefined) {
                                        dueDateNotValid.push(newData);
                                    }
                                }
                            });

                            const DueDateNotValid = new Set(dueDateNotValid.map(item => item.customerPolicyId));
                            const filteredSelectedIds = selectedRows?.filter(item => !DueDateNotValid.has(item.customerPolicyId!))
                            console.log("filteredSelectedIds :", filteredSelectedIds);
                            count++;
                            if (dueDateNotValid.length > 0) {
                                seteditableSelectedRows(filteredSelectedIds)
                                SetCustPolicyNullDueDateData(dueDateNotValid);
                                setOpenPolicyDueDateNullDialog(true);
                            }
                            else {
                                SetCustPolicyNullDueDateData(null);
                                setOpenPolicyDueDateNullDialog(false);
                                seteditableSelectedRows(undefined);
                                updateStatus("Filed", filteredSelectedIds, notes, policySubStatus, dateDeclarationFiled);
                            }
                        }
                        setloading(false);
                        return;
                    } catch (error) {
                        console.error("Error fetching tax type data:", error);
                        return;
                    }
                })();
                return;
            }
        }
        setOpenPolicyDueDateNullDialog(false);

        apiClient(`/PolicyDashBoard/updateCustomerPolicyStatus?status=${status}&&filerName=${user?.userFirstName + ' ' + user?.userlastName}&&filerDate=${encodeURIComponent(mstDateStringToUtcIsoString(noteDate))}&&notes=${notes}&&policySubStatus=${policySubStatus}&&dateDeclarationFiled=${dateDeclarationFiled}`, {


            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(selectedRow)
        })
            .then((res) => {
                setloading(false);
                if (res !== null && res !== undefined) {

                    Swal.fire({
                        title: res.resp === 1 ? 'Error' : 'Success',
                        text: res.message,
                        icon: res.resp === 1 ? 'error' : 'success',
                        confirmButtonColor: '#02A4E3',
                        confirmButtonText: 'OK',
                        customClass: {
                            confirmButton: 'btn-radius',
                            cancelButton: 'btn-radius',
                            popup: 'card-radius'
                        }
                    })
                        .then((result) => {
                            // window.location.reload();
                            setSelectedRows([]);
                            // fetchDataMain("getFlagsPendingReadyReviewFilings", 6, _pageSize, _currentPage);
                            fetchFilingQueueData(currentPage, pageSize);
                        })
                }
            })
            .finally(() => {
                setloading(false);
            });
    }
    interface newProp {
        handleClose: () => void;
        open: boolean;

    }
    const columnsForNullDueDate: GridColDef[] = [
        { field: 'customerPolicyId', headerName: 'Customer Policy Id', width: 150, align: "center", headerAlign: "center" },
        { field: 'policyNumber', headerName: 'Policy Number', width: 150, align: "center", headerAlign: "center" },
        { field: 'insuredName', headerName: 'Insured Name', width: 150, align: "center", headerAlign: "center" },
        { field: 'dueDate', headerName: 'Due Date', width: 150, align: "center", headerAlign: "center" }
    ];
    const [openPolicyDueDateNullDialog, setOpenPolicyDueDateNullDialog] = useState(false);
    const [editableSelectedRows, seteditableSelectedRows] = useState<NewCompletedFilingsModel[]>();
    const [CustPolicyNullDueDateData, SetCustPolicyNullDueDateData] = React.useState<any>();
    function submit() {
        count++;
        updateStatus("Filed", editableSelectedRows);
    }
    const ShowNullFilings = ({ open, handleClose }: newProp) => {
        return (
            <Dialog open={open} onClose={handleClose} maxWidth={'lg'}>
                <DialogTitle className='card-title'>Customer Policy </DialogTitle>
                <DialogContent>
                    <span className="text-danger">Below filings cannot be updated to status "Filed" until 10 days prior to the report due date!</span>
                </DialogContent>
                <DialogContent>
                    <div style={{ height: '50vh', width: '100%' }} >
                        <DataGrid
                            rows={CustPolicyNullDueDateData ?? null}
                            columns={columnsForNullDueDate}
                            pageSize={50}
                            getRowId={(row) => row.customerPolicyId}
                            sx={{ border: "none" }}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn-2 btn d-flex btn-primary search-btn' type='button' onClick={handleClose}>Cancel</button>
                    {editableSelectedRows !== undefined && editableSelectedRows !== null && editableSelectedRows?.length > 0 ?
                        <button className='btn btn-primary active-btn-blue ' type='button' onClick={submit}>Update Rest</button>
                        : ""
                    }

                </DialogActions>
            </Dialog>
        );
    };

    const getTaxTypeData = async (action: string, customerPolicyIds: number[]) => {
        try {
            //  setloading(true);

            const initValueExport = {
                customerPolicyIds: customerPolicyIds,
                option: ''
            };

            const res = await apiClient(`/PolicyDashBoard/${action}`,
                {
                    method: "POST",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    }),
                    body: JSON.stringify(initValueExport)
                }
            );
            if (res?.data != null) {
                return res.data;
            } else {
                throw new Error("Response data is null");
            }
        } catch (error) {
            throw error;
        }
    };
    const status = [
        'Not Started', 'Waiting on Client', 'Ready to File', 'Filed',
        // Note: Disabled intentionally until the workflows are ready.
        // 'Pending Autofile'
    ]
    if (user?.userRoles.split(",").includes("Super Admin")) {
        status.push('Removed');
    }

    function CustomColumnMenu(props: GridColumnMenuProps) {
        const { hideMenu, currentColumn, color, ...other } = props;

        return (
            <GridColumnMenuContainer
                hideMenu={hideMenu}
                currentColumn={currentColumn}
                {...other}
            >
                <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
                <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
                <HideGridColMenuItem onClick={hideMenu} column={currentColumn} />
                <GridColumnsMenuItem onClick={hideMenu} column={currentColumn} />
            </GridColumnMenuContainer>
        );
    }

    return (
        <Box sx={{ height: "calc(100vh - 300px)", display: "flex", flexDirection: "column", width: "100%", borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)', border: '1px solid #e2e8f0', backgroundColor: '#ffffff' }}>
            {loading && <LinearProgress sx={{ backgroundColor: "#2099d2" }} />}
            <div style={{ flex: '1 1 0%', overflow: 'auto' }}>
            <DataGridPro
                apiRef={readyToFileGridApiRef}
                rowHeight={60}
                getRowId={(r) => r.customerPolicyId}
                rows={NewCompletedFilingsCL?.getCompletedFilings_Respdata}
                columns={columns}
                loading={loading}
                pageSize={pageSize}
                pagination
                rowCount={NewCompletedFilingsCL?.totalCount}
                paginationMode="server"
                onPageChange={(newPage) => setCurrentPage(newPage + 1)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={getDetailPanelContent}
                filterMode="server"
                onFilterModelChange={(newFilterModel: any) => setFilterModel(newFilterModel)}
                filterModel={filterModel}
                detailPanelExpandedRowIds={detailPanelExpandedRowIds}
                onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}
                rowsPerPageOptions={getRowsPerPageOptions(NewCompletedFilingsCL?.totalCount, pageSize)}
                sortingMode="server"
                onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                sortModel={sortModel}
                sortingOrder={['desc', 'asc']}
                checkboxSelection={
                    user?.userRoles.split(",").includes("Super Admin") ||
                        user?.userRoles.split(",").includes("MISC Filer") ||
                        user?.userRoles.split(",").includes("MISC State Reporter")
                        ? true : false
                }
                onSelectionModelChange={user?.userRoles.split(",").includes("Super Admin") ||
                    user?.userRoles.split(",").includes("MISC Filer") ||
                    user?.userRoles.split(",").includes("MISC State Reporter")
                    ? (newRowSelectionModel) => {
                        onRowsSelectionHandler(newRowSelectionModel);

                    } : undefined}
                selectionModel={selectedRows?.map((row) => row.customerPolicyId) as GridRowId[]}
                disableSelectionOnClick
                initialState={isTabletOrDown ? undefined : { pinnedColumns: { left: ['dueDate'] } }}
                components={{
                    Toolbar: EditToolbar,
                    ColumnMenu: CustomColumnMenu
                }}
                getRowClassName={(params) => {
                    const isClient =  Number(params.row.isClient ) === 1; 
                    return isClient ? `custom-row-bg-${params.row.isDocsUploaded}` : 'without-documents';
                }}
                sx={{
                    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    border: 'none',
                    fontSize: '14px',
                    color: '#475569',
                    backgroundColor: '#ffffff',
                    "& .MuiDataGrid-detailPanel": {
                        zIndex: 'auto',
                    },
                    // Match MUI X defaults; stay well below theme.zIndex.modal (1300) so dialogs/popovers cover pinned cells.
                    '& .MuiDataGrid-pinnedColumns--left': {
                        zIndex: 1,
                    },
                    '& .MuiDataGrid-pinnedColumnHeaders': {
                        zIndex: 2,
                    },
                    "& .MuiDataGridPro-columnHeaderTitle": {
                        whiteSpace: 'normal',
                        lineHeight: 1.35,
                        fontWeight: 600,
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: '#f8fafc',
                        borderBottom: '2px solid #e2e8f0',
                        borderTop: '2px solid #e2e8f0',
                        minHeight: '52px !important',
                        maxHeight: '52px !important',
                    },
                    "& .MuiDataGrid-columnHeader": {
                        "&:focus, &:focus-within": { outline: 'none' },
                    },
                    "& .MuiDataGrid-row": {
                        transition: 'background-color 0.15s ease',
                        "&:nth-of-type(even)": {
                            backgroundColor: '#fafbfc',
                        },
                        "&:hover": {
                            backgroundColor: '#f1f5f9 !important',
                        },
                        '&.Mui-selected': {
                            backgroundColor: '#ebf5fa !important',
                            '&:hover': {
                                backgroundColor: '#dbeef7 !important',
                            },
                        },
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: '1px solid #f1f5f9',
                        fontSize: '14px',
                        color: '#334155',
                        overflow: 'visible',
                        whiteSpace: 'normal',
                        lineHeight: 'normal',
                        wordWrap: 'break-word',
                        textOverflow: 'clip',
                        "&:focus": { outline: 'none' },
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        border: 'none',
                    },
                    "& .MuiDataGrid-main": {
                        border: 'none',
                    },
                    "& .custom-row-bg-green .MuiDataGrid-cell": { backgroundColor: '#a2dda2' },
                    "& .custom-row-bg-green:hover .MuiDataGrid-cell": { backgroundColor: '#81c781' },
                    "& .custom-row-bg-yellow .MuiDataGrid-cell": { backgroundColor: '#fff9ad' },
                    "& .custom-row-bg-yellow:hover .MuiDataGrid-cell": { backgroundColor: '#f0e68c' },
                    "& .custom-row-bg-red .MuiDataGrid-cell": { backgroundColor: '#f8d7da' },
                    "& .custom-row-bg-red:hover .MuiDataGrid-cell": { backgroundColor: '#f1c2c9' },
                    "& .documents-uploded": { width: '99.6% !important' },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: '1px solid #e2e8f0',
                        backgroundColor: '#f8fafc',
                        minHeight: 56,
                    },
                    "& .MuiTablePagination-root": {
                        color: '#64748b',
                        fontSize: '13px',
                    },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                        marginBottom: 0,
                    },
                    "& .MuiTablePagination-select": {
                        fontSize: '13px',
                        borderRadius: '6px',
                        border: '1px solid #e2e8f0',
                    },
                    "& .MuiIconButton-root": {
                        color: '#64748b',
                        "&:hover": {
                            backgroundColor: '#f1f5f9',
                            color: '#475569',
                        },
                    },
                    "& .MuiCheckbox-root": {
                        color: '#94a3b8',
                        "&.Mui-checked": {
                            color: '#2099d2',
                        },
                    },
                }}
            />
            </div>
            <PolicyDocumentsPopup
                handleClose={handleClose}
                Open={Open}
                documentList={Formdata}
            />
            <PolicyErrorPopup
                handleClose={handleClose}
                Open={OpenError}
                documentList={ErrorFormdata}
            />
            <FilerNotes
                open={openNotesDialog}
                handleClose={handleCloseNotesDialog}
                handleSubmit={handleSubmitNotes}
                selectedRows={selectedRows}
                currentStatus={CurrentStatus}
                currentPolicySubStatus={currentPolicySubStatus}

            />
            <ShowNullFilings handleClose={handleClose} open={openPolicyDueDateNullDialog} />
            <AddDocument
                open={OpenDocResubmission}
                handleClose={handleCloseDocumentUpload}
                customerPolicyId={custPolId}
                currentUser={user ?? undefined}
                viewOnly={false}
            />
        </Box>
    );
};
